import { PlayerValidatorPage } from '@optools/tools/media-validation/components/player-validator-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/media-validation/player-validator')({
  component: RouteComponent,
});

export function RouteComponent() {
  return <PlayerValidatorPage />;
}
